import { useState } from "react";
import {
  MultiSelect,
  MultiSelectChangeEvent,
} from "@progress/kendo-react-dropdowns";

interface Props {
  readonly shipDays: Array<string>;
  readonly setShipDays: (event: Array<string>) => void;
  readonly disabled?: boolean;
}

const data = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];

export default function ShipDaysMultiSelect({
  setShipDays,
  shipDays,
  disabled,
}: Props) {
  const [value, setValue] = useState<string[]>(shipDays);

  const handleChange = (event: MultiSelectChangeEvent) => {
    setValue(event.value);
    setShipDays(event.value);
  };

  return (
    <MultiSelect
      data={data}
      value={value}
      onChange={handleChange}
      autoClose={false}
      size="large"
      disabled={disabled ?? false}
    />
  );
}
